const IT_STORE_PAGE = {
  pageTitle: {
    ja: "パソコン・IT機器販売 | 株式会社NAPIRE",
    en: "PC & IT Equipment Store | NAPIRE Inc.",
  },
  metaDescription: {
    ja: "学生・個人・個人事業主・法人のお客様向けに、パソコン、モニター、プリンター、周辺機器を比較して選べる株式会社NAPIREのITストアです。",
    en: "Compare PCs, monitors, printers, and accessories selected by NAPIRE for students, individuals, sole proprietors, and companies.",
  },
  metaKeywords: {
    ja: "NAPIRE,IT機器,学生向けパソコン,個人向けパソコン,法人向けIT機器,モニター販売,プリンター販売,周辺機器,購入相談,商品比較",
    en: "NAPIRE,IT equipment,student PC,personal PC,business IT equipment,monitor sales,printer sales,accessories,purchase inquiry,comparison",
  },
  heroLabel: { ja: "NAPIRE IT Store", en: "NAPIRE IT Store" },
  heroTitle: {
    ja: "学びにも、仕事にも。\n比べて、選べる。",
    en: "For study and work.\nCompare and choose.",
  },
  heroLead: {
    ja: "学生・個人・個人事業主・法人のお客様へ。授業・就活・在宅ワーク・オフィス導入まで、用途と予算で選べるIT機器を掲載しています。1点からご購入を相談でき、表示価格は税込です。",
    en: "For students, individuals, sole proprietors, and companies. Find IT equipment for classes, job hunting, remote work, and offices. Inquiries are welcome from a single item; listed prices include tax.",
  },
  heroCta: { ja: "商品を比較する", en: "Compare products" },
  heroCta2: { ja: "購入・見積を相談", en: "Ask about purchase or a quote" },
  countLabel: { ja: "厳選商品", en: "Selected products" },
  productsLabel: { ja: "Selected equipment", en: "Selected equipment" },
  productsTitle: { ja: "用途と予算で選べる36商品", en: "36 products for different needs and budgets" },
  productsLead: {
    ja: "授業・就活・自宅作業・仕事環境に使えるPC、モニター、プリンター、周辺機器を横断して比較できます。市場の販売価格と在庫を確認し、選びやすい価格帯の商品を厳選しました。",
    en: "Compare PCs, monitors, printers, and accessories for classes, job hunting, home projects, and work. Each item was selected after reviewing stock and current retail pricing.",
  },
  categories: [
    { key: "all", label: { ja: "すべて", en: "All" } },
    { key: "pc", label: { ja: "パソコン", en: "PCs" } },
    { key: "monitor", label: { ja: "モニター", en: "Monitors" } },
    { key: "printer", label: { ja: "プリンター", en: "Printers" } },
    { key: "accessory", label: { ja: "周辺機器", en: "Accessories" } },
  ],
  searchLabel: { ja: "商品を検索", en: "Search products" },
  searchPlaceholder: { ja: "商品名・型番・用途で検索", en: "Search by name, model, or use" },
  sortLabel: { ja: "並び順", en: "Sort" },
  sortOptions: [
    { key: "recommended", label: { ja: "おすすめ順", en: "Recommended" } },
    { key: "price-asc", label: { ja: "価格が安い順", en: "Price: low to high" } },
    { key: "price-desc", label: { ja: "価格が高い順", en: "Price: high to low" } },
  ],
  resultLabel: { ja: "件の商品", en: "products" },
  noResults: { ja: "条件に合う商品がありません。検索条件を変更してください。", en: "No products match these filters." },
  featuredLabel: { ja: "おすすめ", en: "Featured" },
  compareToggle: { ja: "比較に追加", en: "Add to compare" },
  compareSelected: { ja: "商品を選択中", en: "selected" },
  compareOpen: { ja: "比較表を見る", en: "View comparison" },
  compareClear: { ja: "選択を解除", en: "Clear" },
  compareLimit: { ja: "比較できる商品は3つまでです。", en: "You can compare up to three products." },
  compareTitle: { ja: "選択した商品の比較", en: "Compare selected products" },
  compareClose: { ja: "閉じる", en: "Close" },
  compareQuote: { ja: "選択商品をまとめて相談", en: "Ask about selected products" },
  compareRows: {
    category: { ja: "カテゴリー", en: "Category" },
    price: { ja: "掲載価格（税込）", en: "Listed price (tax incl.)" },
    features: { ja: "主な仕様・特徴", en: "Key features" },
    stock: { ja: "在庫", en: "Stock" },
  },
  taxIncluded: { ja: "税込", en: "tax incl." },
  shippingNote: { ja: "送料別・購入前にご案内", en: "Shipping confirmed before purchase" },
  quoteCta: { ja: "購入・在庫を問い合わせ", en: "Ask about purchase and stock" },
  makerCta: { ja: "製品情報", en: "Product details" },
  stockNote: { ja: "在庫確認済み（2026年8月8日）", en: "Stock checked Aug 8, 2026" },
  processLabel: { ja: "How it works", en: "How it works" },
  processTitle: { ja: "ご相談からお届けまで", en: "From inquiry to delivery" },
  process: [
    {
      title: { ja: "商品と数量を送信", en: "Send product and quantity" },
      text: { ja: "1点でも複数点でもご相談可能です。比較機能で候補を絞るか、商品カードから数量・お届け先・希望時期をお知らせください。", en: "Ask about one item or several. Shortlist products with comparison, then tell us quantity, delivery address, and preferred timing." },
    },
    {
      title: { ja: "在庫・送料を確認", en: "We confirm stock and shipping" },
      text: { ja: "最新の在庫、納期、送料を確認し、ご購入内容をご案内します。複数台の場合は正式なお見積書も発行します。", en: "We confirm current stock, lead time, and shipping. A formal quotation is also available for multi-unit orders." },
    },
    {
      title: { ja: "ご注文・お届け", en: "Order and delivery" },
      text: { ja: "内容をご確認いただいた後に商品を手配します。初期設定、複数台、学校・事務所への納品もご相談いただけます。", en: "We arrange the order after confirmation. Setup, multi-unit orders, and delivery to schools or offices are also available." },
    },
  ],
  noticeTitle: { ja: "価格・ご注文について", en: "Pricing and orders" },
  notices: [
    { ja: "学生・個人・個人事業主・法人のお客様にご購入いただけます。表示価格は1台または1個あたりの税込価格です。", en: "Students, individuals, sole proprietors, and companies can purchase. Prices shown are tax-inclusive per unit." },
    { ja: "市場価格・仕入価格・在庫は変動するため、正式な価格と納期はご購入前に確定します。", en: "Market and supply prices and stock change; final price and lead time are confirmed before purchase." },
    { ja: "送料、設置、初期設定、延長保証などは納品条件に応じて別途お見積します。", en: "Shipping, installation, setup, and extended warranty are quoted separately as needed." },
    { ja: "商品画像は参考です。色・形状・付属品などが実際の構成と異なる場合があります。", en: "Product images are for reference. Color, shape, and included accessories may vary by configuration." },
  ],
  ctaTitle: { ja: "1点から複数台までご相談ください", en: "Ask about one item or a full setup" },
  ctaText: { ja: "授業・就活・自宅作業用の1台から、PC・モニター・周辺機器のまとめ買い、初期設定やクラウド導入まで対応します。", en: "From one device for classes, job hunting, or home projects to bundled PCs, monitors, accessories, setup, and cloud rollout support." },
  ctaBtn: { ja: "購入・まとめ買いを相談", en: "Ask about purchase or bundles" },
}

const IT_STORE_PRODUCTS = [
  {
    id: "vaio-pro-pg", group: "pc", type: "laptop", theme: "vaio", featured: true,
    maker: "VAIO", model: "VJPG324000007", price: 242000, stock: "50",
    name: { ja: "VAIO Pro PG", en: "VAIO Pro PG" },
    category: { ja: "13.3型 モバイルノートPC", en: "13.3-inch mobile laptop" },
    tagline: { ja: "約1.0kg。外出先でも仕事を止めない。", en: "About 1.0kg for productive work on the move." },
    desc: { ja: "Windows 11 Pro、Core 5、メモリ16GBを約1.0kgの筐体に搭載。顔・指紋認証と3年保証を備えた法人向けモバイルPCです。", en: "A roughly 1.0kg business laptop with Windows 11 Pro, Core 5, 16GB memory, biometric login, and a three-year warranty." },
    makerUrl: "https://vaio.com/business/pg32/spec_std/",
    highlights: [{ ja: "約1.0kg", en: "About 1.0kg" }, { ja: "Core 5 / 16GB", en: "Core 5 / 16GB" }, { ja: "SSD 256GB", en: "256GB SSD" }, { ja: "3年保証", en: "3-year warranty" }],
  },
  {
    id: "vaio-pro-bm", group: "pc", type: "laptop", theme: "vaio", featured: true,
    maker: "VAIO", model: "VJBM124000007", price: 219800, stock: "74",
    name: { ja: "VAIO Pro BM", en: "VAIO Pro BM" },
    category: { ja: "16型 ビジネスノートPC", en: "16-inch business laptop" },
    tagline: { ja: "大きな画面と、3年保証の安心を。", en: "A larger workspace with a three-year warranty." },
    desc: { ja: "Windows 11 Pro、Core 5、メモリ16GBを備えた法人向けPC。表計算、資料作成、Web会議を1台で快適にこなせます。", en: "A reliable business PC with Windows 11 Pro, Core 5, and 16GB memory for spreadsheets, presentations, and video meetings." },
    makerUrl: "https://vaio.com/business/bm12/spec_std/",
    highlights: [{ ja: "Core 5 / 16GB", en: "Core 5 / 16GB" }, { ja: "SSD 256GB", en: "256GB SSD" }, { ja: "16型 WUXGA", en: "16-inch WUXGA" }, { ja: "3年保証", en: "3-year warranty" }],
  },
  {
    id: "dell-pro-15-essential", group: "pc", type: "laptop", theme: "dell", featured: true,
    maker: "Dell", model: "NBLA155-014N1", price: 159800, stock: "100+",
    name: { ja: "Dell Pro 15 Essential", en: "Dell Pro 15 Essential" },
    category: { ja: "15.6型 ビジネスノートPC", en: "15.6-inch business laptop" },
    tagline: { ja: "標準業務を、無理のない予算で。", en: "Everyday business performance at a practical price." },
    desc: { ja: "第13世代Core i5、メモリ16GB、Windows 11 Proを搭載。バックオフィスや拠点配備に向くベーシックモデルです。", en: "A practical deployment model with a 13th-gen Core i5, 16GB memory, and Windows 11 Pro." },
    makerUrl: "https://www.dell.com/ja-jp/shop/dell-laptops/scr/laptops/appref=dell-pro-essential-product-line",
    highlights: [{ ja: "Core i5 / 16GB", en: "Core i5 / 16GB" }, { ja: "SSD 256GB", en: "256GB SSD" }, { ja: "15.6型 FHD", en: "15.6-inch FHD" }, { ja: "Windows 11 Pro", en: "Windows 11 Pro" }],
  },
  {
    id: "hp-probook-4-g1a", group: "pc", type: "laptop", theme: "hp",
    maker: "HP", model: "BT6H7PT-AAAA", price: 191800, stock: "100+",
    name: { ja: "HP ProBook 4 G1a 14", en: "HP ProBook 4 G1a 14" },
    category: { ja: "14型 ビジネスノートPC", en: "14-inch business laptop" },
    tagline: { ja: "持ち運びと処理性能のバランス。", en: "Balanced mobility and processing power." },
    desc: { ja: "Ryzen 7、メモリ16GB、SSD 512GBを搭載。オフィス内の移動と日常業務の快適さを両立します。", en: "Ryzen 7, 16GB memory, and a 512GB SSD balance office mobility with responsive daily work." },
    makerUrl: "https://jp.ext.hp.com/prod/notebooks/business/hp_probook_4_g1a_14/",
    highlights: [{ ja: "Ryzen 7 / 16GB", en: "Ryzen 7 / 16GB" }, { ja: "SSD 512GB", en: "512GB SSD" }, { ja: "14型", en: "14-inch" }, { ja: "Windows 11 Pro", en: "Windows 11 Pro" }],
  },
  {
    id: "iodata-lcd-a241db", group: "monitor", type: "monitor", theme: "display", featured: true,
    maker: "I-O DATA", model: "LCD-A241DB", price: 12800, stock: "100+",
    name: { ja: "LCD-A241DB", en: "LCD-A241DB" },
    category: { ja: "23.8型 フルHDモニター", en: "23.8-inch Full HD monitor" },
    tagline: { ja: "5年保証で、標準席を整える。", en: "A five-year warranty for standard workstations." },
    desc: { ja: "広視野角ADSパネルとスピーカーを搭載した23.8型。複数台の一括導入にも向く定番モニターです。", en: "A 23.8-inch monitor with a wide-view ADS panel, speakers, and a five-year warranty." },
    makerUrl: "https://www.iodata.jp/product/lcd/bizwide/lcd-a241db/",
    highlights: [{ ja: "23.8型 FHD", en: "23.8-inch FHD" }, { ja: "ADSパネル", en: "ADS panel" }, { ja: "スピーカー", en: "Speakers" }, { ja: "5年保証", en: "5-year warranty" }],
  },
  {
    id: "lg-24ms500-b", group: "monitor", type: "monitor", theme: "display",
    maker: "LG", model: "24MS500-B", price: 12280, stock: "100+",
    name: { ja: "24MS500-B", en: "24MS500-B" },
    category: { ja: "23.8型 100Hz IPSモニター", en: "23.8-inch 100Hz IPS monitor" },
    tagline: { ja: "滑らかな表示を、日常のデスクへ。", en: "Smoother everyday work with a 100Hz display." },
    desc: { ja: "フルHDのIPSパネルと100Hz表示に対応。スクロールや画面切り替えが多い業務にも扱いやすいモデルです。", en: "A Full HD IPS panel with a 100Hz refresh rate for smooth scrolling and everyday office work." },
    makerUrl: "https://www.lg.com/jp/monitors/fhd-qhd/24ms500-b/",
    highlights: [{ ja: "23.8型 FHD", en: "23.8-inch FHD" }, { ja: "IPSパネル", en: "IPS panel" }, { ja: "100Hz", en: "100Hz" }, { ja: "HDMI×2", en: "2× HDMI" }],
  },
  {
    id: "benq-gw2791", group: "monitor", type: "monitor", theme: "display",
    maker: "BenQ", model: "GW2791", price: 15980, stock: "56",
    name: { ja: "GW2791", en: "GW2791" },
    category: { ja: "27型 アイケアモニター", en: "27-inch Eye-Care monitor" },
    tagline: { ja: "資料を広く、目にやさしく。", en: "More space with eye-comfort features." },
    desc: { ja: "27型の広い作業領域に、ブルーライト軽減とフリッカーフリーを搭載。長時間のデスクワークに向きます。", en: "A roomy 27-inch display with low blue light and flicker-free technology for longer desk sessions." },
    makerUrl: "https://www.benq.com/ja-jp/monitor/home/gw2791.html",
    highlights: [{ ja: "27型 FHD", en: "27-inch FHD" }, { ja: "アイケア", en: "Eye-Care" }, { ja: "ノングレア", en: "Anti-glare" }, { ja: "100Hz", en: "100Hz" }],
  },
  {
    id: "philips-241s9a", group: "monitor", type: "monitor", theme: "display",
    maker: "Philips", model: "241S9A/11", price: 12980, stock: "100+",
    name: { ja: "241S9A/11", en: "241S9A/11" },
    category: { ja: "23.8型 フルHDモニター", en: "23.8-inch Full HD monitor" },
    tagline: { ja: "省スペースで、見やすい標準サイズ。", en: "A clear, space-efficient standard display." },
    desc: { ja: "23.8型フルHD、スピーカー搭載の実用モデル。会議室や固定席への追加導入にも適しています。", en: "A practical 23.8-inch Full HD display with speakers for desks and meeting rooms." },
    makerUrl: "https://www.philips.co.jp/c-p/241S9A_11/lcd-monitor",
    highlights: [{ ja: "23.8型 FHD", en: "23.8-inch FHD" }, { ja: "ノングレア", en: "Anti-glare" }, { ja: "スピーカー", en: "Speakers" }, { ja: "5年保証", en: "5-year warranty" }],
  },
  {
    id: "canon-lbp621c", group: "printer", type: "printer-color", theme: "color", featured: true,
    maker: "Canon", model: "3104C010", price: 19800, stock: "52",
    name: { ja: "Satera LBP621C", en: "Satera LBP621C" },
    category: { ja: "A4 カラーレーザープリンター", en: "A4 color laser printer" },
    tagline: { ja: "省スペースで、資料を鮮やかに。", en: "Compact color output for everyday documents." },
    desc: { ja: "カラー・モノクロとも高速出力。無線LAN対応で置き場所を選びにくく、提案書や販促資料を社内で印刷できます。", en: "Fast color and monochrome output with wireless LAN for flexible placement." },
    makerUrl: "https://canon.jp/biz/product/printer/satera/lbp/lineup/622c-621c",
    highlights: [{ ja: "A4カラー", en: "A4 color" }, { ja: "無線 / 有線LAN", en: "Wireless / wired LAN" }, { ja: "省スペース", en: "Compact" }, { ja: "毎分18枚", en: "18 ppm" }],
  },
  {
    id: "epson-px-m6011f", group: "printer", type: "printer-multi", theme: "color",
    maker: "EPSON", model: "PX-M6011F", price: 42800, stock: "30",
    name: { ja: "PX-M6011F", en: "PX-M6011F" },
    category: { ja: "A3 カラーインクジェット複合機", en: "A3 color inkjet multifunction printer" },
    tagline: { ja: "A3対応を、身近な複合機で。", en: "Accessible A3 printing, scanning, copying, and fax." },
    desc: { ja: "A3印刷、コピー、スキャン、FAXに対応した2段カセットモデル。図面や掲示物を扱う小規模オフィスに向きます。", en: "A two-tray A3 multifunction model for printing, copying, scanning, and faxing." },
    makerUrl: "https://www.epson.jp/products/bizprinter/pxm6011f/",
    highlights: [{ ja: "A3対応", en: "A3 support" }, { ja: "2段カセット", en: "Dual trays" }, { ja: "コピー / FAX", en: "Copy / fax" }, { ja: "無線 / 有線LAN", en: "Wireless / wired LAN" }],
  },
  {
    id: "canon-mf753cdw", group: "printer", type: "printer-multi", theme: "color",
    maker: "Canon", model: "5455C011", price: 78900, stock: "17",
    name: { ja: "Satera MF753Cdw", en: "Satera MF753Cdw" },
    category: { ja: "A4 カラーレーザー複合機", en: "A4 color laser multifunction printer" },
    tagline: { ja: "カラー業務を、一台に集約。", en: "Consolidate everyday color document workflows." },
    desc: { ja: "プリント、コピー、スキャン、FAXを1台に集約。両面同時読取ADFと大型タッチパネルを備えた業務向けモデルです。", en: "Print, copy, scan, and fax with a duplex ADF and a large touchscreen." },
    makerUrl: "https://canon.jp/biz/product/printer/satera/mfp/lineup/mf755cdw-mf753cdw",
    highlights: [{ ja: "A4カラー複合機", en: "A4 color MFP" }, { ja: "両面同時読取", en: "Duplex scanning" }, { ja: "FAX対応", en: "Fax" }, { ja: "無線 / 有線LAN", en: "Wireless / wired LAN" }],
  },
  {
    id: "elecom-m-k6urbk", group: "accessory", type: "mouse", theme: "supply",
    maker: "ELECOM", model: "M-K6URBK/RS", price: 990, stock: "100+",
    name: { ja: "法人向けUSB光学式マウス", en: "Business USB Optical Mouse" },
    category: { ja: "有線マウス", en: "Wired mouse" },
    tagline: { ja: "配備しやすい、シンプルな定番。", en: "A simple, deployment-friendly standard mouse." },
    desc: { ja: "USB接続の3ボタン光学式マウス。電池交換や接続設定が不要で、複数席への一括導入にも向きます。", en: "A three-button USB optical mouse with no batteries or pairing required." },
    makerUrl: "https://www.elecom.co.jp/products/M-K6URBKRS.html",
    highlights: [{ ja: "USB有線", en: "Wired USB" }, { ja: "3ボタン", en: "3 buttons" }, { ja: "Mサイズ", en: "Medium size" }, { ja: "RoHS準拠", en: "RoHS compliant" }],
  },
  {
    id: "elecom-m-k7brbk", group: "accessory", type: "mouse", theme: "supply",
    maker: "ELECOM", model: "M-K7BRBK/RS", price: 2180, stock: "100+",
    name: { ja: "法人向け高耐久Bluetoothマウス", en: "Durable Business Bluetooth Mouse" },
    category: { ja: "Bluetoothマウス", en: "Bluetooth mouse" },
    tagline: { ja: "ケーブルレスと、3年保証。", en: "Cable-free convenience with a three-year warranty." },
    desc: { ja: "1000万回の高耐久スイッチと3年保証を備えた法人向けモデル。USBポートを塞がずに使えます。", en: "A business model with durable switches, a three-year warranty, and no USB receiver required." },
    makerUrl: "https://www.elecom.co.jp/products/M-K7BRBKRS.html",
    highlights: [{ ja: "Bluetooth 4.0", en: "Bluetooth 4.0" }, { ja: "1000万回耐久", en: "10M-click durability" }, { ja: "3年保証", en: "3-year warranty" }, { ja: "3ボタン", en: "3 buttons" }],
  },
  {
    id: "elecom-esl-404", group: "accessory", type: "lock", theme: "supply",
    maker: "ELECOM", model: "ESL-404", price: 3180, stock: "100+",
    name: { ja: "マルチ対応セキュリティワイヤーロック", en: "Multi-slot Security Cable Lock" },
    category: { ja: "PC盗難防止", en: "PC theft prevention" },
    tagline: { ja: "鍵を増やさず、持ち出しを抑止。", en: "Deter device theft without managing keys." },
    desc: { ja: "3種のセキュリティスロットに対応する4桁ダイヤル式。共有PCや受付端末の盗難対策に使えます。", en: "A four-digit combination cable lock supporting three common security slot types." },
    makerUrl: "https://www.elecom.co.jp/products/ESL-404.html",
    highlights: [{ ja: "4桁ダイヤル", en: "4-digit dial" }, { ja: "3スロット対応", en: "3 slot types" }, { ja: "キー不要", en: "Keyless" }, { ja: "ワイヤー一体", en: "Integrated cable" }],
  },
  {
    id: "elecom-ef-pfk156w", group: "accessory", type: "filter", theme: "supply", featured: true,
    maker: "ELECOM", model: "EF-PFK156W", price: 5680, stock: "100+",
    name: { ja: "抗菌のぞき見防止フィルター 15.6型", en: "15.6-inch Antibacterial Privacy Filter" },
    category: { ja: "プライバシーフィルター", en: "Privacy filter" },
    tagline: { ja: "移動中や共有空間の画面情報を守る。", en: "Protect on-screen information in shared spaces." },
    desc: { ja: "左右からの視線を遮り、表面の抗菌加工にも対応。15.6型16:9ノートPC向けです。", en: "Limits side viewing and adds an antibacterial surface for 15.6-inch 16:9 laptops." },
    makerUrl: "https://www.elecom.co.jp/products/EF-PFK156W.html",
    highlights: [{ ja: "15.6型 16:9", en: "15.6-inch 16:9" }, { ja: "のぞき見防止", en: "Privacy protection" }, { ja: "抗菌加工", en: "Antibacterial" }, { ja: "両面対応", en: "Reversible" }],
  },
  {
    id: "elecom-ad-hdmivgabk2", group: "accessory", type: "adapter", theme: "supply",
    maker: "ELECOM", model: "AD-HDMIVGABK2", price: 1850, stock: "100+",
    name: { ja: "HDMI-VGA変換アダプター", en: "HDMI-to-VGA Adapter" },
    category: { ja: "映像変換アダプター", en: "Video adapter" },
    tagline: { ja: "新しいPCを、既存の設備へ。", en: "Connect newer PCs to existing display equipment." },
    desc: { ja: "HDMI出力をVGA入力へ変換。会議室の既存プロジェクターや旧型モニターを活用できます。", en: "Converts HDMI output to VGA for existing projectors and older monitors." },
    makerUrl: "https://www.elecom.co.jp/products/AD-HDMIVGABK2.html",
    highlights: [{ ja: "HDMI→VGA", en: "HDMI to VGA" }, { ja: "約15cm", en: "About 15cm" }, { ja: "バスパワー", en: "Bus powered" }, { ja: "RoHS準拠", en: "RoHS compliant" }],
  },
  {
    id: "elecom-tk-fcm062bk", group: "accessory", type: "keyboard", theme: "supply",
    maker: "ELECOM", model: "TK-FCM062BK", price: 1390, stock: "100+",
    name: { ja: "法人向け高耐久USBキーボード", en: "Durable Business USB Keyboard" },
    category: { ja: "有線フルキーボード", en: "Wired full-size keyboard" },
    tagline: { ja: "テンキー付きの標準配列を、各席へ。", en: "A familiar full layout for every workstation." },
    desc: { ja: "108キー日本語配列と1000万回の高耐久キーを採用。デスクトップPCや固定席への一括配備に向きます。", en: "A 108-key Japanese layout with durable keys for fixed desks and desktop PCs." },
    makerUrl: "https://www.elecom.co.jp/products/TK-FCM062BK.html",
    highlights: [{ ja: "USB有線", en: "Wired USB" }, { ja: "108キー", en: "108 keys" }, { ja: "テンキー付き", en: "Numeric keypad" }, { ja: "1000万回耐久", en: "10M-keystroke durability" }],
  },
]

const createCatalogProduct = ({ id, group, type, theme, maker, model, price, stock = "在庫あり", featured = false, name, category, tagline, desc, makerUrl, highlights }) => ({
  id, group, type, theme, maker, model, price, stock, featured,
  name: { ja: name, en: name },
  category: { ja: category, en: category },
  tagline: { ja: tagline, en: tagline },
  desc: { ja: desc, en: desc },
  makerUrl,
  highlights: highlights.map((value) => ({ ja: value, en: value })),
})

const IT_STORE_ADDITIONAL_PRODUCTS = [
  createCatalogProduct({
    id: "panasonic-fc6-core-ultra5", group: "pc", type: "laptop", theme: "hp", maker: "Panasonic", model: "CF-FC6RDAAS", price: 314000, featured: true,
    name: "Let’s note FC6", category: "14型 法人向けモバイルPC", tagline: "軽さと堅牢性を、毎日の持ち運びへ。",
    desc: "Core Ultra 5、16GBメモリ、SSD 512GBを搭載。社内外を移動する担当者に向く法人向けモバイルPCです。",
    makerUrl: "https://connect.panasonic.com/jp-ja/products-services/letsnote/lineup/fc", highlights: ["Core Ultra 5", "16GB / 512GB", "14型", "Windows 11 Pro"],
  }),
  createCatalogProduct({
    id: "panasonic-fc6-core-ultra7", group: "pc", type: "laptop", theme: "hp", maker: "Panasonic", model: "CF-FC6RD7AS", price: 331000,
    name: "Let’s note FC6", category: "14型 高性能モバイルPC", tagline: "重い業務も持ち歩ける上位構成。",
    desc: "Core Ultra 7と16GBメモリを備え、資料作成やWeb会議を並行する業務にも余裕を持たせたモデルです。",
    makerUrl: "https://connect.panasonic.com/jp-ja/products-services/letsnote/lineup/fc", highlights: ["Core Ultra 7", "16GB / 512GB", "14型", "Windows 11 Pro"],
  }),
  createCatalogProduct({
    id: "panasonic-sc6", group: "pc", type: "laptop", theme: "hp", maker: "Panasonic", model: "CF-SC6RDAAS", price: 309000,
    name: "Let’s note SC6", category: "12.4型 法人向けモバイルPC", tagline: "小さなフットプリントで、機動力を高める。",
    desc: "12.4型の携帯性とCore Ultra 5、16GBメモリを両立。外出や出張が多い業務に適しています。",
    makerUrl: "https://connect.panasonic.com/jp-ja/products-services/letsnote/lineup/sc", highlights: ["12.4型", "Core Ultra 5", "16GB / 512GB", "Windows 11 Pro"],
  }),
  createCatalogProduct({
    id: "dell-pro-14-plus", group: "pc", type: "laptop", theme: "dell", maker: "Dell", model: "NBLA150-012H1", price: 280000, featured: true,
    name: "Dell Pro 14 Plus", category: "14型 高性能ビジネスPC", tagline: "処理性能と持ち運びを一台で。",
    desc: "複数アプリを使う日常業務やオンライン会議に向く14型法人モデル。拠点配備にも個別導入にも対応します。",
    makerUrl: "https://www.dell.com/ja-jp/shop/dell-laptops-and-2-in-1-pcs/scr/laptops/appref=dell-pro-plus-product-line", highlights: ["14型", "Windows 11 Pro", "法人向け", "持ち運び対応"],
  }),
  createCatalogProduct({
    id: "dmm-dks-4k43dg6", group: "monitor", type: "monitor", theme: "display", maker: "DMM.make", model: "DKS-4K43DG6", price: 40500, featured: true,
    name: "DMM.make 43型 4Kモニター", category: "43型 4Kディスプレイ", tagline: "会議室やサイネージに、大画面4K。",
    desc: "43型・4K解像度で、会議資料や案内表示を大きく見せたい環境に向くディスプレイです。",
    makerUrl: "https://distribution.dmm.com/monitor/", highlights: ["43型", "4K", "HDMI", "会議室・表示用途"],
  }),
  createCatalogProduct({
    id: "hp-series3-322pf", group: "monitor", type: "monitor", theme: "display", maker: "HP", model: "9U5B0UT#ABJ", price: 11900,
    name: "HP Series 3 Pro 322pf", category: "21.5型 フルHDモニター", tagline: "省スペースな標準席を、手頃に。",
    desc: "21.5型フルHDの法人向けモニター。受付、固定席、サブディスプレイへの追加導入に向きます。",
    makerUrl: "https://jp.ext.hp.com/monitors/business/", highlights: ["21.5型 FHD", "非光沢", "HDMI", "VESA対応"],
  }),
  createCatalogProduct({
    id: "hp-series3-324pv", group: "monitor", type: "monitor", theme: "display", maker: "HP", model: "9U5C1AA#ABJ", price: 11650,
    name: "HP Series 3 Pro 324pv", category: "23.8型 フルHDモニター", tagline: "日常業務の標準サイズを低コストで。",
    desc: "23.8型フルHDのVAパネルを採用。資料作成やWeb業務用の標準モニターとして導入しやすい構成です。",
    makerUrl: "https://jp.ext.hp.com/monitors/business/", highlights: ["23.8型 FHD", "VAパネル", "HDMI", "3年保証"],
  }),
  createCatalogProduct({
    id: "hp-series3-324pf", group: "monitor", type: "monitor", theme: "display", maker: "HP", model: "9U5J5UT#ABJ", price: 14900,
    name: "HP Series 3 Pro 324pf", category: "23.8型 フルHDモニター", tagline: "接続端子を揃えた法人向け標準モデル。",
    desc: "HDMI、DisplayPort、VGAに対応する23.8型。既存PCと新しいPCが混在するオフィスにも導入しやすいモデルです。",
    makerUrl: "https://jp.ext.hp.com/monitors/business/", highlights: ["23.8型 FHD", "HDMI / DP / VGA", "非光沢", "法人向け"],
  }),
  createCatalogProduct({
    id: "iodata-lcd-a241dw", group: "monitor", type: "monitor", theme: "display", maker: "I-O DATA", model: "LCD-A241DW", price: 13580,
    name: "LCD-A241DW", category: "23.8型 フルHDモニター", tagline: "明るいデスクに馴染むホワイトモデル。",
    desc: "広視野角ADSパネルとスピーカーを搭載。受付や明るい内装のオフィスにも合わせやすいホワイト筐体です。",
    makerUrl: "https://www.iodata.jp/product/lcd/bizwide/lcd-a241db/", highlights: ["23.8型 FHD", "ADSパネル", "スピーカー", "5年保証"],
  }),
  createCatalogProduct({
    id: "oki-c835dnw", group: "printer", type: "printer-color", theme: "color", maker: "OKI", model: "C835DNW", price: 93900, featured: true,
    name: "COREFIDO EX C835dnw", category: "A3 カラーLEDプリンター", tagline: "A3カラーを、高速・高耐久で。",
    desc: "カラー・モノクロ約35枚/分のA3対応機。提案資料、図面、掲示物を社内で多く出力する業務に向きます。",
    makerUrl: "https://www.oki.com/jp/printing/products/color/c835dnw/", highlights: ["A3カラー", "無線 / 有線LAN", "自動両面", "高耐久"],
  }),
  createCatalogProduct({
    id: "elecom-cac-dp1215", group: "accessory", type: "adapter", theme: "supply", maker: "ELECOM", model: "CAC-DP1215BK", price: 2190,
    name: "DisplayPortケーブル 1.5m", category: "映像ケーブル", tagline: "PCとモニターを安定して接続。",
    desc: "DisplayPort端子を持つPCとモニターの接続に使える1.5mケーブル。標準席の配線に扱いやすい長さです。",
    makerUrl: "https://www.elecom.co.jp/products/CAC-DP1215BK.html", highlights: ["DisplayPort", "1.5m", "4K対応", "ブラック"],
  }),
  createCatalogProduct({
    id: "elecom-cac-dp1250", group: "accessory", type: "adapter", theme: "supply", maker: "ELECOM", model: "CAC-DP1250BK", price: 5950,
    name: "DisplayPortケーブル 5m", category: "長尺映像ケーブル", tagline: "会議室や離れた機器を長尺で接続。",
    desc: "5mのDisplayPortケーブル。会議室、受付、壁面モニターなど機器間に距離がある配線に向きます。",
    makerUrl: "https://www.elecom.co.jp/products/CAC-DP1250BK.html", highlights: ["DisplayPort", "5m", "4K対応", "長尺配線"],
  }),
  createCatalogProduct({
    id: "elecom-dh-hd14el10", group: "accessory", type: "adapter", theme: "supply", maker: "ELECOM", model: "DH-HD14EL10/RS", price: 660,
    name: "HDMIケーブル 1m", category: "HDMIケーブル", tagline: "デスク上の短距離接続をすっきり。",
    desc: "PC、モニター、プロジェクターを接続する1mのHDMIケーブル。席ごとの追加配備にも向きます。",
    makerUrl: "https://www.elecom.co.jp/products/DH-HD14EL10RS.html", highlights: ["HDMI", "1m", "4K対応", "簡易パッケージ"],
  }),
  createCatalogProduct({
    id: "elecom-dh-hd14el15", group: "accessory", type: "adapter", theme: "supply", maker: "ELECOM", model: "DH-HD14EL15/RS", price: 740,
    name: "HDMIケーブル 1.5m", category: "HDMIケーブル", tagline: "標準席や会議室で使いやすい長さ。",
    desc: "1.5mのHDMIケーブル。ノートPCとモニター、会議用PCとディスプレイの接続に使えます。",
    makerUrl: "https://www.elecom.co.jp/products/DH-HD14EL15RS.html", highlights: ["HDMI", "1.5m", "4K対応", "簡易パッケージ"],
  }),
  createCatalogProduct({
    id: "elecom-usb4-cc5p08", group: "accessory", type: "adapter", theme: "supply", maker: "ELECOM", model: "USB4-CC5P08BK", price: 3790, featured: true,
    name: "USB4 Type-Cケーブル 0.8m", category: "高速USB-Cケーブル", tagline: "映像・データ・給電を一本に。",
    desc: "USB4対応のType-Cケーブル。対応機器間の高速データ転送、映像出力、USB PD給電に使えます。",
    makerUrl: "https://www.elecom.co.jp/products/USB4-CC5P08BK.html", highlights: ["USB4", "最大40Gbps", "USB PD", "0.8m"],
  }),
  createCatalogProduct({
    id: "elecom-dh-hd14el30", group: "accessory", type: "adapter", theme: "supply", maker: "ELECOM", model: "DH-HD14EL30/RS", price: 1290,
    name: "HDMIケーブル 3m", category: "HDMIケーブル", tagline: "少し離れた会議機器にも届く3m。",
    desc: "3mのHDMIケーブル。会議机から壁面ディスプレイまでなど、余裕を持たせたい配線に向きます。",
    makerUrl: "https://www.elecom.co.jp/products/DH-HD14EL30RS.html", highlights: ["HDMI", "3m", "4K対応", "会議室向け"],
  }),
  createCatalogProduct({
    id: "elecom-dh-hd14el50", group: "accessory", type: "adapter", theme: "supply", maker: "ELECOM", model: "DH-HD14EL50/RS", price: 1240,
    name: "HDMIケーブル 5m", category: "長尺HDMIケーブル", tagline: "離れたディスプレイまで一本で接続。",
    desc: "5mのHDMIケーブル。壁面モニターやプロジェクターなど、距離がある機器への配線に使えます。",
    makerUrl: "https://www.elecom.co.jp/products/DH-HD14EL50RS.html", highlights: ["HDMI", "5m", "4K対応", "長尺配線"],
  }),
  createCatalogProduct({
    id: "elecom-usb-ecoea20", group: "accessory", type: "adapter", theme: "supply", maker: "ELECOM", model: "USB-ECOEA20", price: 960,
    name: "USB2.0延長ケーブル 2m", category: "USB延長ケーブル", tagline: "USB機器の置き場所を、もう少し自由に。",
    desc: "USB Type-Aを2m延長できるケーブル。プリンター、Webカメラ、USBハブなどの配置調整に使えます。",
    makerUrl: "https://www.elecom.co.jp/products/USB-ECOEA20.html", highlights: ["USB2.0", "2m", "Type-A延長", "RoHS準拠"],
  }),
  createCatalogProduct({
    id: "elecom-cac-15", group: "accessory", type: "adapter", theme: "supply", maker: "ELECOM", model: "CAC-15BK/RS", price: 1460,
    name: "VGAディスプレイケーブル 1.5m", category: "映像ケーブル", tagline: "既存モニターやプロジェクターを活用。",
    desc: "VGA端子を持つPC、モニター、プロジェクターを接続する1.5mケーブル。既存設備の延命に役立ちます。",
    makerUrl: "https://www.elecom.co.jp/products/CAC-15BKRS.html", highlights: ["VGA", "1.5m", "スリム", "RoHS準拠"],
  }),
]

const IT_STORE_PRODUCT_IMAGES = {
  "vaio-pro-pg": "assets/it-store-products/vaio-pro-pg.jpg",
  "vaio-pro-bm": "assets/it-store-products/vaio-pro-bm.jpg",
  "dell-pro-15-essential": "assets/it-store-products/dell-pro-15-essential.jpg",
  "hp-probook-4-g1a": "assets/it-store-products/hp-probook-4-g1a.jpg",
  "iodata-lcd-a241db": "assets/it-store-products/iodata-lcd-a241db.jpg",
  "lg-24ms500-b": "assets/it-store-products/lg-24ms500-b.jpg",
  "benq-gw2791": "assets/it-store-products/benq-gw2791.jpg",
  "philips-241s9a": "assets/it-store-products/philips-241s9a.jpg",
  "canon-lbp621c": "assets/it-store-products/canon-lbp621c.jpg",
  "epson-px-m6011f": "assets/it-store-products/epson-px-m6011f.jpg",
  "canon-mf753cdw": "assets/it-store-products/canon-mf753cdw.jpg",
  "elecom-m-k6urbk": "assets/it-store-products/elecom-m-k6urbk.jpg",
  "elecom-m-k7brbk": "assets/it-store-products/elecom-m-k7brbk.jpg",
  "elecom-esl-404": "assets/it-store-products/elecom-esl-404.jpg",
  "elecom-ef-pfk156w": "assets/it-store-products/elecom-ef-pfk156w.jpg",
  "elecom-ad-hdmivgabk2": "assets/it-store-products/elecom-ad-hdmivgabk2.jpg",
  "elecom-tk-fcm062bk": "assets/it-store-products/elecom-tk-fcm062bk.jpg",
  "panasonic-fc6-core-ultra5": "assets/it-store-products/panasonic-fc6.jpg",
  "panasonic-fc6-core-ultra7": "assets/it-store-products/panasonic-fc6.jpg",
  "panasonic-sc6": "assets/it-store-products/panasonic-sc6.jpg",
  "dell-pro-14-plus": "assets/it-store-products/dell-pro-14-plus.jpg",
  "dmm-dks-4k43dg6": "assets/it-store-products/dmm-dks-4k43dg6.jpg",
  "hp-series3-322pf": "assets/it-store-products/hp-series3-322pf.jpg",
  "hp-series3-324pv": "assets/it-store-products/hp-series3-324pv.jpg",
  "hp-series3-324pf": "assets/it-store-products/hp-series3-324pf.jpg",
  "iodata-lcd-a241dw": "assets/it-store-products/iodata-lcd-a241dw.jpg",
  "oki-c835dnw": "assets/it-store-products/oki-c835dnw.jpg",
  "elecom-cac-dp1215": "assets/it-store-products/elecom-cac-dp1215.jpg",
  "elecom-cac-dp1250": "assets/it-store-products/elecom-cac-dp1250.jpg",
  "elecom-dh-hd14el10": "assets/it-store-products/elecom-dh-hd14el10.jpg",
  "elecom-dh-hd14el15": "assets/it-store-products/elecom-dh-hd14el15.jpg",
  "elecom-usb4-cc5p08": "assets/it-store-products/elecom-usb4-cc5p08.jpg",
  "elecom-dh-hd14el30": "assets/it-store-products/elecom-dh-hd14el30.jpg",
  "elecom-dh-hd14el50": "assets/it-store-products/elecom-dh-hd14el50.jpg",
  "elecom-usb-ecoea20": "assets/it-store-products/elecom-usb-ecoea20.jpg",
  "elecom-cac-15": "assets/it-store-products/elecom-cac-15.jpg",
}

function getItStoreProducts() {
  return [...IT_STORE_PRODUCTS, ...IT_STORE_ADDITIONAL_PRODUCTS].map((product) => ({
    ...product,
    imageUrl: IT_STORE_PRODUCT_IMAGES[product.id] || "",
  }))
}
